import React from "react";
import { useSelector } from "react-redux";
import { BlockTitle, CustomButton, CustomTextField, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import UsersListTable from "./users-list-table/UsersListTable";
import styles from "./UsersList.module.css";

export default function UsersList({
	COMPANY_ROLES = [],
	onChangeLock,
	onChangeRole,
	onChangeSearchValue,
	onClickRow,
	onRegenPassword,
	searchValue = "",
	selectedUser,
	setIsAdding,
	usersRequest,
}) {
	const loggedUser = useSelector(({ context }) => context.user);
	return (
		<>
			<BlockTitle>{translate("dsi.user-list.title")}</BlockTitle>
			<div className={styles.headerContainer}>
				<CustomTextField
					className={styles.searchInput}
					placeholder={translate("dsi.dsi-user.search-user")}
					value={searchValue}
					onChange={onChangeSearchValue}
				/>
				<CustomButton
					data-testid="add.user.button"
					startIcon={icon.faPlus}
					variant="contained"
					onClick={() => setIsAdding(true)}
				>
					{translate("dsi.dsi-user.add-user")}
				</CustomButton>
			</div>
			<UsersListTable
				COMPANY_ROLES={COMPANY_ROLES}
				loggedUser={loggedUser}
				selectedUser={selectedUser}
				usersRequest={usersRequest}
				onChangeLock={onChangeLock}
				onChangeRole={onChangeRole}
				onRegenPassword={onRegenPassword}
				onSelectRow={onClickRow}
			/>
		</>
	);
}
